import { FunctionComponent, useEffect, useState, Suspense } from 'react';
import { App } from '@app/index';
import { AppConfig } from '@bootstrap/config';
import { BrowserRouter} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

export const AppRoot: FunctionComponent = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Load runtime config
    new AppConfig().loader().then(() => setIsLoaded(true));
  }, []);

  return isLoaded ? (
    <Suspense fallback>
      <HelmetProvider>
        <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </Suspense>
  ) : null;
};
